import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  baseUrl: 'https://ca-cctrl-prod-api.greenstone-1c8c1ce7.germanywestcentral.azurecontainerapps.io/v1/',
  // baseUrl: 'https://localhost:44305/v1/',
  clientId: '223f56ec-09c2-4b08-b484-3e24c518d50c',
  frontendUrl: 'https://dashboard.whiteduck.de',
  // frontendUrl: 'http://localhost:4200',
  microsoftGraphUserEndpoint: 'https://graph.microsoft.com/v1.0/users/',
  authenticationMethodResetPath: '/authentication/methods/28c10230-6103-485e-b985-444c60001490/resetPassword/',
  defaultThemeName: 'white-duck',
  // costControlProxyUrl: 'http://localhost:5196',
  costControlProxyUrl: 'https://ca-wd-prod-cc.purplebush-81621a18.germanywestcentral.azurecontainerapps.io',
};
